import { render, staticRenderFns } from "./WPSwitch.vue?vue&type=template&id=dd4eb3be"
import script from "./WPSwitch.vue?vue&type=script&lang=ts"
export * from "./WPSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports